import { NAMES } from '../constants/general';
import PATH from '../constants/paths';
import { isFHT } from './miscUtil';

export type AwardPaymentTitleBarPathOptions = {
  history: { push: (path: string) => void };
  roles?: unknown[];
  SeniorStore?: { alumni?: boolean; setSenior?: (value: unknown) => void };
  isAdminOrFHTRole: boolean;
  isUserAlumni: boolean;
  seniorDisplayName: string;
  requestContextUserId?: number;
  includeAwardPaymentList?: boolean;
  awardPaymentListPath?: string;
  awardPaymentListName?: string;
};

export const buildAwardPaymentTitleBarPaths = ({
  history,
  roles = [],
  SeniorStore,
  isAdminOrFHTRole,
  isUserAlumni,
  seniorDisplayName,
  requestContextUserId,
  includeAwardPaymentList = false,
  awardPaymentListPath,
  awardPaymentListName,
}: AwardPaymentTitleBarPathOptions) => {
  const paths = [{ path: '/', name: 'Home', onClickFunc: null }];

  if (requestContextUserId && isAdminOrFHTRole) {
    paths.push({
      path: '/',
      name: isUserAlumni ? NAMES.ALUMNI : NAMES.SENIORS,
      onClickFunc: () => {
        if (typeof SeniorStore?.setSenior === 'function') {
          SeniorStore.setSenior(null);
        }
        if (SeniorStore?.alumni) {
          history.push(PATH.ALUMNI_LIST);
        } else if (isFHT(roles)) {
          history.push(PATH.FAMILY_HOME_LIST);
        } else {
          history.push(PATH.SENIOR_LIST);
        }
      },
    });

    paths.push({
      path: '/',
      name: seniorDisplayName || 'Senior',
      onClickFunc: () => history.push(PATH.SENIOR_PLANNER),
    });
  }

  if (includeAwardPaymentList && awardPaymentListPath && awardPaymentListName) {
    paths.push({
      path: awardPaymentListPath,
      name: awardPaymentListName,
      onClickFunc: null,
    });
  }

  return paths;
};
